import * as React from 'react';
import Translate from '../../../common/functions/translate';
import MedicineService from '../../../services/medicineService';
import { InteractionsDataModel, DrugToFoodAlcoholInteraction } from '../../../models';
import getInteractionSeverity from '../MedicineCommon/interactionsSeverityFunctions';
import AlertMessage from '../../../common/components/alertMessage/alertMessage';
import Spinner from '../../../common/components/spinner/spinner';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import InteractionDrugToFoodDialog from './interactionDrugToFoodDialog';

interface IProps {
  medicineId: any,
  history: any,
  lang: string
}

interface IState {
  isLoading: boolean;
  medicineId: number;
  error: any;
  interactionsData: InteractionsDataModel;
  isVisibleInteractionDialog: boolean;
  currentDrugToFoodAlcoholInteraction: DrugToFoodAlcoholInteraction;
  currentMedicineName: string;
}

class drugToFoodInteractions extends React.Component<IProps, IState> {
  medicineService = new MedicineService(this.props.lang);

  constructor(props: IProps) {
    super(props);

    let interactionsData = new InteractionsDataModel();
    interactionsData.drugToFoodAlcoholInteractions = new Array<DrugToFoodAlcoholInteraction>(0);

    this.state = {
      error: null,
      isLoading: false,
      medicineId: this.props.medicineId,
      interactionsData: interactionsData,
      isVisibleInteractionDialog: false,
      currentDrugToFoodAlcoholInteraction: new DrugToFoodAlcoholInteraction(),
      currentMedicineName: ''
    };
  }

  componentDidMount() {
    this.getDrugToFoodData();
  }

  getDrugToFoodData = () => {
    this.setState({
      isLoading: true
    });

    this.medicineService.getDrugToFoodData(this.state.medicineId).then(
      (data: any) => {
        this.setState({
          isLoading: false,
          interactionsData: data.data
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          error
        });
      });
  }

  handleInteractionTabClick = (e, drugToFoodAlcoholInteraction: DrugToFoodAlcoholInteraction, medicineName: string) => {
    e.preventDefault();
    this.setState({
      isVisibleInteractionDialog: true,
      currentDrugToFoodAlcoholInteraction: drugToFoodAlcoholInteraction,
      currentMedicineName: medicineName
    });
  }

  handleCloseDialogClick = () => {
    this.setState({
      isVisibleInteractionDialog: false
    });
  }

  public render() {
    const { isLoading, error, interactionsData, isVisibleInteractionDialog, currentDrugToFoodAlcoholInteraction, currentMedicineName } = this.state;

    return (
      <div>
        {isLoading ? <Spinner /> : null}
        {error ? <AlertMessage type='danger'>Error: {error.message}</AlertMessage> : null}

        <div>
          <h4>{Translate('Alcohol and food interactions with')} {interactionsData.brandName} ({interactionsData.genericName}):</h4>
          <ul className="list-items">
            {interactionsData.drugToFoodAlcoholInteractions.map(m =>
              <li key={m.foodAlcoholId + m.selectedIngredientId + m.interactionTypeId}
                onClick={(e) => this.handleInteractionTabClick(e, m, interactionsData.brandName + (interactionsData.genericName))}
              >
                <div className="item-info">
                  <div className="item-name">
                    {getInteractionSeverity('icon', m.interactionTypeId)}
                    {m.foodAlcoholName ? m.foodAlcoholName : ''}
                  </div>
                </div>
                <div className="item-actions">
                  <FontAwesomeIcon icon={faChevronRight} />
                </div>
              </li>
            )}
          </ul>
        </div>

        {isVisibleInteractionDialog ? (
          <InteractionDrugToFoodDialog
            isVisible={isVisibleInteractionDialog}
            closeClick={this.handleCloseDialogClick}
            drugToFoodAlcoholInteraction={currentDrugToFoodAlcoholInteraction}
            medicineName={currentMedicineName}
          />) : null
        }

      </div>
    )
  }
}

const mapsStateToProps = state => {
  return {
    lang: state.common.lang
  };
}

export default connect(mapsStateToProps, null)(drugToFoodInteractions);
